import { ShippingTime } from '@app/models/shipping-time';
import {
  ShippingTimeActionsUnion,
  ShippingTimeActionTypes
} from '@core/actions/shipping-time.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<ShippingTime> {
  loading: boolean;
  loaded: boolean;
  creating: boolean;
  messageLoading: string;
  shippingTimes: any
}
export const getState = createFeatureSelector<State>('shippingTimes');


export const adapter: EntityAdapter<ShippingTime> = createEntityAdapter<
  ShippingTime
>({
  selectId: (shippingTime: ShippingTime) => shippingTime.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  creating: false,
  messageLoading: "",
  shippingTimes: []
});

export function reducer(
  state: State = INITIAL_STATE,
  action: ShippingTimeActionsUnion
) {
  switch (action.type) {
    case ShippingTimeActionTypes.Load:
      return { ...state, loading: true };

    case ShippingTimeActionTypes.LoadFail:
      return { ...state, loading: false };

    case ShippingTimeActionTypes.LoadSuccess:
      return {
        ...state,
        loading: false,
        loaded: true,
        shippingTimes: action.shippingTimes
      };
    case ShippingTimeActionTypes.Create:
      return { ...state, creating: true };

    case ShippingTimeActionTypes.Export:
    case ShippingTimeActionTypes.RefreshShippingTimes:
      return { ...state, loading: true }
    
    case ShippingTimeActionTypes.ExportSuccess:
    case ShippingTimeActionTypes.RefreshShippingTimesSuccess:
      return { ...state, loading: false }
        
    case ShippingTimeActionTypes.UploadSuccess:
      return {...state, shippingTimes: action.data}

    case ShippingTimeActionTypes.CreateFail:
    case ShippingTimeActionTypes.CreateSuccess:
      return { ...state, creating: false };

    case ShippingTimeActionTypes.AddAll:
      return adapter.addAll(action.shippingTimes, state);

    case ShippingTimeActionTypes.AddOne:
      return adapter.addOne(action.shippingTime, state);

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const getLoading = (state: State) => state.loading
export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const getSpinnerMessage = (state: State) => state.messageLoading;
export const getShippingTimes = createSelector(
  getState,
  (state: State) => state.shippingTimes
)

